import React, { useState, useEffect } from 'react';
import cx from 'classnames';

import { IHeader2Fields } from '@/types/contentful';

import { usePageDataContext } from '../../context/PageData';
import { useCookie } from '../../hooks/useCookie';
import { useScrollPosition } from '../../hooks/useScrollPosition';

import { Banners } from '../Body/Banners';
import { DesktopNavbar } from './Viewports/DesktopNav/DesktopNavComponents';
import { NavItem as MobileNav } from './Viewports/MobileNav';
import { SubNavigation } from '../SubNavigation';
import AppIncidentBanner from '../WebBanner/AppIncidentBanner';

export function Navbar(props: IHeader2Fields) {
  const {
    appIncident = false,
    page: { hideHeader, hideBanner, isSimplified, pageWebBanner } = {},
    cookies: {
      gl_web_banner: glWebBanner,
      gl_is_registered_user: registeredUser,
      partner: partner
    } = {}
  } = usePageDataContext();

  const [isScrolled, setIsScrolled] = useState(false);
  // Default banner display status from server cookie and page prop
  const [incidentVisible, setIncidentVisible] = useState(appIncident);
  const [bannerVisible, updateBanner] = useState(
    glWebBanner === 'show' && registeredUser !== 'true' && hideBanner !== true
  );

  // Use client cookie to manage for banner status
  const [wbCookie, updateCookie] = useCookie('gl_web_banner');
  const [ruCookie] = useCookie('gl_is_registered_user');

  useEffect(() => {
    // Sync incident visibility with appIncident flag
    setIncidentVisible(appIncident);
  }, [appIncident]);

  useEffect(() => {
    // Update regular banner visibility when cookie or page settings change
    updateBanner(
      wbCookie === 'show' && ruCookie !== 'true' && hideBanner !== true
    );
  }, [wbCookie, ruCookie, hideBanner]);

  useScrollPosition(
    ({ currPos }) => {
      if (currPos.y > 0) setIsScrolled(true);
      else if (currPos.y <= 0) setIsScrolled(false);
    },
    [isScrolled],
    undefined,
    true,
    100
  );

  return (
    <>
      {incidentVisible && (
        <AppIncidentBanner
          toggleBanner={() => setIncidentVisible(false)}
          roundedCornersVariation={props.roundedCornersVariation}
        />
      )}

      {!incidentVisible && bannerVisible && (
        <Banners
          toggleBanner={updateCookie}
          roundedCornersVariation={props.roundedCornersVariation}
          pageWebBanner={pageWebBanner}
        />
      )}

      {!hideHeader && (
        <div
          className={cx('z-[9999] w-full', {
            'max-w-screen-2xl mx-auto my-0': props.roundedCornersVariation
          })}
        >
          <MobileNav
            {...props}
            isSimplified={!!isSimplified}
            isScrolled={isScrolled}
            partner={partner}
          />
          <DesktopNavbar
            {...props}
            isSimplified={!!isSimplified}
            isScrolled={isScrolled}
            isSubNavigationPresent={!!props.subNavigation?.fields}
            partner={partner}
          />
          {props.subNavigation?.fields && (
            <SubNavigation {...props.subNavigation.fields} />
          )}
        </div>
      )}
    </>
  );
}
